import { produce } from "immer";
import React, { useMemo } from "react";

import { ChartData, Cartesian } from "@examspark/types";

import BasicChart from "../../chart/BasicChart";

import BarChartBar from "./BarChartBar";

interface Props {
  graph: Cartesian.Graph;
  data: ChartData;
  onChange?: (data: ChartData) => void;
}

const BarChart: React.FC<React.PropsWithChildren<Props>> = ({
  onChange,
  ...props
}) => {
  const graph = useMemo(() => {
    return produce(props.graph, (draft) => {
      draft.x.max = props.data.length + 1;
      draft.height = 400;
      draft.width = 500;
    });
  }, [props.data, props.graph]);

  return (
    <BasicChart graph={graph} data={props.data}>
      {props.data.map((d, idx) => {
        return (
          <BarChartBar
            key={idx}
            width={230 / (props.data.length || 2)}
            position={idx}
            label={d.label}
            value={d.value}
            onChange={(c) => {
              onChange?.(
                produce(props.data, (draft) => {
                  draft[idx].value = c.y;
                }),
              );
            }}
          />
        );
      })}
    </BasicChart>
  );
};

export default BarChart;
